import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent } from '../../components/icon/icon.component';

@Component({
  selector: 'td-wb-inline-notification',
  templateUrl: 'inline-notification.component.html',
  styleUrls: ['inline-notification.component.scss'],
  imports: [
    IconComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InlineNotificationComponent {

  @Input()
  public iconId: string = 'triangle-warning';
}
